import { gql } from '@apollo/client';

export default gql`
  mutation createSuggestion(
    $title: String
    $desc: String
    $category: String
    $priority: String
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $departmentId: String
    $attachments: [AttachmentInput]
  ) {
    createSuggestion(
      title: $title
      desc: $desc
      category: $category
      priority: $priority
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      departmentId: $departmentId
      attachments: $attachments
    ) {
      ok
      error
      data
    }
  }
`;
